import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = () => {
  const { userCookies } = useAuth();
  return userCookies ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
